





























import {Vue, Component, Prop} from "vue-property-decorator";
import {UserProfile} from "../../../api/models/UserProfile";
import { Point } from "../../../api/models/Point";
import UserIcon from "../../../share/common/UserIcon.vue";
import Diamond from '../../../assets/svg/diamond.svg';

@Component({
    components: { UserIcon, Diamond }
})
export default class UserPointInfo extends Vue {
    @Prop() points: Point;
    @Prop() profile: UserProfile;

    get pointsAmount() {
        return this.points?.points || 0;
    }
}
